import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-placeholder';
import '../../common/bn-property';

class InstallationBinLocation extends LitEntity {
  static get styles() {
    return sharedStyles;
  }

  render() {
    if (!this.entity) {
      return html`<bn-placeholder></bn-placeholder>`;
    }
    return html`
      <bn-property label="Address">
        ${this.entity.properties.location.address}
      </bn-property>
      <bn-property label="Latitude">
        ${this.entity.properties.location.latitude}
      </bn-property>
      <bn-property label="Longitude">
        ${this.entity.properties.location.longitude}
      </bn-property>
    `;
  }
}

window.customElements.define('installation-bin-location', InstallationBinLocation);
